import { LastThingEvent } from '@eagle/core-data-types';
import { get } from 'lodash';
import { DateTime } from 'luxon';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { formatValue } from '../../../util';
import { FormatTimestamp, ListPaperColumn, Tooltip } from '../../widgets';

const DAYS = 30;

interface LastThingEventColumnProps {
  label: string;
  formatter: 'distance' | 'duration';
  feature: string;
  eventTypeId: string;
  path: string;
  lastThingEvents: LastThingEvent[];
  wrap?: boolean;
}

export const LastThingEventColumn: FC<LastThingEventColumnProps> = ({ label, formatter, lastThingEvents, feature, path, eventTypeId, wrap, ...props }) => {
  const { t } = useTranslation(['common']);
  const rangeLimit = DateTime.now().minus({ days: DAYS });

  const event = lastThingEvents.find((event) =>
    event.feature === feature &&
    event.eventTypeId === eventTypeId &&
    DateTime.fromJSDate(event.occurred) >= rangeLimit,
  );
  const value = event ? get(event, path) as number : null;

  return (
    <ListPaperColumn label={label} wrap={wrap} {...props}>
      <Tooltip title={event ? <FormatTimestamp value={event.occurred} /> : ''}>
        <span>{value === null || value === undefined ?
          t('common:page.transfers-list.no-last-thing-event-data.labels', { count: DAYS })
          : formatValue(value, formatter)}
        </span>
      </Tooltip>
    </ListPaperColumn>
  );
};
